import layout from '@views/layout/index.vue';

const guestRoutes = [
  {
    path: '/gp',
    name: 'nav',
    component: layout,
    children: [
      // 新加我
      {
        path: 'guest',
        name: 'guest',
        component: () => import('@views/mine/index.vue'),
        redirect: 'mine/mineindex',
        children: [
          {
            path: 'otherindex/:id?',
            name: 'otherindex',
            meta: {
              pageType: 'hispage',
              pageName: '客态主页',
              keepAlive: false,
              hideTopNav: false,
              hideRightNav: true,
              showDetailTopNav: true,
            },
            component: () => import(/* webpackChunkName: "otherindex" */'@views/mine/mainpage/otherindex/index.vue'),
          },
          {
            path: 'datainterest/:id?',
            name: 'guestdatainterest',
            meta: {
              pageType: 'guestdatainterest',
              pageName: '客态趣味数据',
              keepAlive: false,
              showDetailTopNav: true,
              hideRightNav: true,
            },
            component: () => import(/* webpackChunkName: "otherdatainterest" */'@views/mine/mainpage/otherdatainterest/index.vue'),
          },
          {
            path: 'datagrenade/:id?',
            name: 'guestdatagrenade',
            meta: {
              pageType: 'guestdatagrenade',
              pageName: '客态道具数据',
              keepAlive: false,
              showDetailTopNav: true,
              hideRightNav: true,
            },
            component: () => import(/* webpackChunkName: "otherdatagrenade" */'@views/mine/mainpage/otherdatagrenade/index.vue'),
          },
          {
            path: 'guestdatafriend/:id?',
            name: 'guestdatafriend',
            meta: {
              pageType: 'guestdatafriend',
              pageName: '客态好友排行',
              keepAlive: false,
              showDetailTopNav: true,
              hideRightNav: true,
            },
            component: () => import(/* webpackChunkName: "otherdatafriend" */'@views/mine/mainpage/otherdatafriend/index.vue'),
          },
        ],
      },
      // 他的粉丝
      {
        path: '/gp/mine/otherfan/:id',
        name: 'otherfan',
        meta: {
          pageType: 'hispage-fans',
          pageName: '客态粉丝列表',
          keepAlive: false,
          hideTopNav: true,
          hideRightNav: true,
          showDetailTopNav: true,
        },
        component: () => import(/* webpackChunkName: "otherfan" */'@views/mine/mainpage/otherfan/index.vue'),
      },
      // 他的关注
      {
        path: '/gp/mine/otherattention/:id',
        name: 'otherattention',
        meta: {
          pageType: 'hispage-attention',
          pageName: '客态关注列表',
          keepAlive: false,
          hideTopNav: true,
          hideRightNav: true,
          showDetailTopNav: true,
        },
        component: () => import(/* webpackChunkName: "otherattention" */'@views/mine/mainpage/otherattention/index.vue'),
      },
    ],
  },
];

function addMeta(guestRoutes) {
  guestRoutes.children.forEach((route) => {
    if (route.children) {
      addMeta(route);
      return;
    }
    route.meta.sideBar = 'guest';
  });
}
addMeta(guestRoutes[0]);

export default guestRoutes;
